/**
 * GBWhatsApp 深蓝琥珀系主题配置 - 全站组件级变量
 * 包含所有 UI 组件的主题颜色
 */

export const themes = [
  {
    id: 'emerald',
    name: 'Deep Blue',
    nameCn: '深海蓝',
    icon: '💎',
    description: '专业沉稳，深蓝琥珀主调',
    colors: {
      // ========== 品牌主色 ==========
      primary: '#1E3A5F',
      primaryDark: '#0F2347',
      primaryLight: '#3B82C4',
      primaryPale: '#EBF2FC',
      primaryBg: '#F0F5FB',
      primaryBorder: 'rgba(30,58,95,0.15)',

      // ========== 渐变 ==========
      gradient: 'linear-gradient(135deg, #0F2347 0%, #1E3A5F 100%)',
      gradientLight: 'linear-gradient(135deg, #1E3A5F 0%, #3B82C4 100%)',
      gradientDark: 'linear-gradient(135deg, #0a1a35 0%, #0F2347 100%)',
      logoGradient: 'linear-gradient(135deg, #0F2347 0%, #1E3A5F 100%)',
      footerGradient: 'linear-gradient(135deg, #0a1a35 0%, #0F2347 100%)',
      heroGradient: 'linear-gradient(135deg, #0F2347 0%, #1E3A5F 100%)',

      // ========== 页面背景 ==========
      pageBg: '#f4f7fb',
      sectionBg: '#ffffff',
      sectionAltBg: '#eef3f9',
      cardBg: '#ffffff',
      cardBg2: '#f8fafd',

      // ========== 文字 ==========
      textMain: '#0F2347',
      textBody: '#2d3748',
      textMuted: '#64748b',
      textFaint: '#94a3b8',
      textInverse: '#ffffff',
      textBrand: '#1E3A5F',
      textBrandDark: '#0F2347',

      // ========== 导航栏 ==========
      navBg: 'rgba(255,255,255,0.97)',
      navBorder: 'rgba(30,58,95,0.1)',
      navHover: '#1E3A5F',
      navActive: '#0F2347',
      navText: '#0F2347',
      mobileMenuBg: 'rgba(240,245,251,0.98)',
      mobileMenuBorder: 'rgba(30,58,95,0.1)',

      // ========== 按钮 ==========
      btnBg: '#1E3A5F',
      btnBgDark: '#0F2347',
      btnText: '#ffffff',
      btnTextDark: '#ffffff',
      btnShadow: 'rgba(30,58,95,0.35)',
      btnShadowDark: 'rgba(15,35,71,0.45)',
      btnRadius: '999px',
      btnRadiusSm: '12px',
      btnBorder: 'transparent',

      // Ghost 按钮
      ghostBtnBg: 'transparent',
      ghostBtnText: '#1E3A5F',
      ghostBtnBorder: '#1E3A5F',

      // 卡片下载按钮（琥珀色突出 CTA）
      cardDownloadBg: '#F59E0B',
      cardDownloadHover: '#D97706',
      cardDownloadText: '#ffffff',

      // 底部固定下载按钮
      fixedBtnBg: 'linear-gradient(135deg, #0F2347 0%, #1E3A5F 100%)',
      fixedBtnText: '#ffffff',

      // ========== 卡片 ==========
      cardBorder: 'rgba(30,58,95,0.1)',
      cardBorderHover: 'rgba(30,58,95,0.22)',
      cardShadow: '0 2px 12px rgba(30,58,95,0.06)',
      cardShadowMd: '0 4px 20px rgba(30,58,95,0.08)',
      cardShadowLg: '0 12px 40px rgba(30,58,95,0.12)',
      cardRadius: '16px',

      // ========== 底部栏 ==========
      footerBg: '#0a1a35',
      footerBg2: '#0F2347',
      footerText: '#ffffff',
      footerTextMuted: 'rgba(255,255,255,0.75)',
      footerLink: 'rgba(255,255,255,0.85)',
      footerLinkHover: '#ffffff',

      // ========== 边框 ==========
      border: 'rgba(30,58,95,0.1)',
      borderMid: 'rgba(30,58,95,0.18)',
      borderStrong: 'rgba(30,58,95,0.3)',
      borderInverse: 'rgba(255,255,255,0.15)',

      // ========== 标签/徽章 ==========
      badgeBg: '#EBF2FC',
      badgeText: '#1E3A5F',
      badgeBorder: 'rgba(30,58,95,0.2)',
      badgeDot: '#1E3A5F',

      // ========== 功能标签（Works / Risky / Info） ==========
      tagWorksBg: '#d1fae5',
      tagWorksText: '#065f46',
      tagRiskyBg: '#fef3c7',
      tagRiskyText: '#92400e',
      tagInfoBg: '#e0f2fe',
      tagInfoText: '#0369a1',
      tagDangerBg: '#fee2e2',
      tagDangerText: '#dc2626',
      tagWarnBg: '#fef3c7',
      tagWarnText: '#d97706',

      // ========== 表格 ==========
      tableHeaderBg: '#EBF2FC',
      tableHeaderText: '#1E3A5F',
      tableRowEven: '#F0F5FB',
      tableRowOdd: '#ffffff',
      tableBorder: 'rgba(30,58,95,0.12)',
      tableCellHighlight: '#1E3A5F',
      tableCellWarn: '#92400e',
      tableCellDanger: '#dc2626',

      // ========== 专题区块 ==========
      highlightSectionBg: '#EBF2FC',
      highlightSectionBorder: 'rgba(30,58,95,0.2)',
      calloutBg: '#EBF2FC',
      calloutBorder: '#1E3A5F',
      calloutText: '#1E3A5F',

      // ========== 评价 verdict ==========
      verdictGreenBg: '#f0fdf4',
      verdictGreenText: '#166534',
      verdictRedBg: '#fef2f2',
      verdictRedText: '#991b1b',

      // ========== 快速导航 ==========
      quickNavBg: '#ffffff',
      quickNavBorder: 'rgba(30,58,95,0.1)',
      quickNavText: '#64748b',
      quickNavNum: '#1E3A5F',
      quickNavHoverBg: '#EBF2FC',
      quickNavHoverText: '#1E3A5F',

      // ========== FAQ ==========
      faqSectionBg: '#ffffff',
      faqSectionBorder: 'rgba(30,58,95,0.12)',
      faqQuestionBg: '#f8fafd',
      faqQuestionText: '#0F2347',
      faqAnswerBg: '#F0F5FB',

      // ========== 回到顶部 ==========
      backtopBg: '#1E3A5F',
      backtopShadow: 'rgba(30,58,95,0.35)',
      backtopIcon: '#ffffff',

      // ========== 危险/警告 ==========
      riskText: '#b45309',
      dangerBg: '#fee2e2',
      dangerText: '#dc2626',
      warnBg: '#fef3c7',
      warnText: '#d97706',
      infoBg: '#e0f2fe',
      infoText: '#0369a1',

      // ========== 特殊样式 ==========
      dividerColor: 'rgba(30,58,95,0.12)',
      dividerLight: 'rgba(0,0,0,0.06)',
      selectionBg: 'rgba(30,58,95,0.2)',
      scrollbarThumb: 'rgba(30,58,95,0.3)',

      // ========== 下载页专用 ==========
      dlcardBg: '#f8fafd',
      dlcardBorder: 'rgba(30,58,95,0.15)',
      dlcardTitleText: '#0F2347',
      dlcardSubText: '#64748b',
      dlpriceTagBg: '#FEF3C7',
      dlpriceTagText: '#92400e',
      dlverifiedBg: '#EBF2FC',
      dlverifiedText: '#1E3A5F',

      // 下载表格（深色主题）
      guideTableBorder: '2px solid #1E3A5F',
      guideTableHeaderBg: '#0F2347',
      guideTableCellBg: '#1E3A5F',
      guideTableText: '#ffffff',
    },
  },
  {
    id: 'whatsapp',
    name: 'WhatsApp Green',
    nameCn: 'WhatsApp 原生绿',
    icon: '📱',
    description: '与 WhatsApp 品牌一致，最推荐',
    colors: {
      primary: '#25D366',
      primaryDark: '#128C7E',
      primaryLight: '#7CD992',
      primaryPale: '#E8F5E9',
      primaryBg: '#F9FBF9',
      primaryBorder: 'rgba(37,211,102,0.15)',

      gradient: 'linear-gradient(135deg, #128C7E 0%, #25D366 100%)',
      gradientLight: 'linear-gradient(135deg, #25D366 0%, #7CD992 100%)',
      gradientDark: 'linear-gradient(135deg, #075E54 0%, #128C7E 100%)',
      logoGradient: 'linear-gradient(135deg, #075E54 0%, #25D366 100%)',
      footerGradient: 'linear-gradient(135deg, #075E54 0%, #128C7E 100%)',
      heroGradient: 'linear-gradient(135deg, #075E54 0%, #25D366 100%)',

      pageBg: '#f5faf7',
      sectionBg: '#ffffff',
      sectionAltBg: '#f0f9f4',
      cardBg: '#ffffff',
      cardBg2: '#fafffe',

      textMain: '#1a1a1a',
      textBody: '#3d3d3d',
      textMuted: '#6b6b6b',
      textFaint: '#9a9a9a',
      textInverse: '#ffffff',
      textBrand: '#25D366',
      textBrandDark: '#128C7E',

      navBg: 'rgba(255,255,255,0.97)',
      navBorder: 'rgba(37,211,102,0.12)',
      navHover: '#25D366',
      navActive: '#128C7E',
      navText: '#1a1a1a',
      mobileMenuBg: 'rgba(232,245,233,0.98)',
      mobileMenuBorder: 'rgba(37,211,102,0.1)',

      btnBg: '#25D366',
      btnBgDark: '#128C7E',
      btnText: '#ffffff',
      btnTextDark: '#ffffff',
      btnShadow: 'rgba(37,211,102,0.35)',
      btnShadowDark: 'rgba(18,140,126,0.4)',
      btnRadius: '999px',
      btnRadiusSm: '12px',
      btnBorder: 'transparent',

      ghostBtnBg: 'transparent',
      ghostBtnText: '#25D366',
      ghostBtnBorder: '#25D366',

      cardDownloadBg: '#25D366',
      cardDownloadHover: '#128C7E',
      cardDownloadText: '#ffffff',

      fixedBtnBg: 'linear-gradient(135deg, #128C7E 0%, #25D366 100%)',
      fixedBtnText: '#ffffff',

      cardBorder: 'rgba(37,211,102,0.1)',
      cardBorderHover: 'rgba(37,211,102,0.25)',
      cardShadow: '0 2px 12px rgba(37,211,102,0.06)',
      cardShadowMd: '0 4px 20px rgba(37,211,102,0.08)',
      cardShadowLg: '0 12px 40px rgba(37,211,102,0.12)',
      cardRadius: '16px',

      footerBg: '#075E54',
      footerBg2: '#128C7E',
      footerText: '#ffffff',
      footerTextMuted: 'rgba(255,255,255,0.75)',
      footerLink: 'rgba(255,255,255,0.85)',
      footerLinkHover: '#ffffff',

      border: 'rgba(37,211,102,0.1)',
      borderMid: 'rgba(37,211,102,0.18)',
      borderStrong: 'rgba(37,211,102,0.3)',
      borderInverse: 'rgba(255,255,255,0.15)',

      badgeBg: '#E8F5E9',
      badgeText: '#128C7E',
      badgeBorder: 'rgba(37,211,102,0.2)',
      badgeDot: '#25D366',

      tagWorksBg: '#dcfce7',
      tagWorksText: '#166534',
      tagRiskyBg: '#fef3c7',
      tagRiskyText: '#92400e',
      tagInfoBg: '#e0f2fe',
      tagInfoText: '#0369a1',
      tagDangerBg: '#fee2e2',
      tagDangerText: '#dc2626',
      tagWarnBg: '#fef3c7',
      tagWarnText: '#d97706',

      tableHeaderBg: '#E8F5E9',
      tableHeaderText: '#128C7E',
      tableRowEven: '#f0f9f4',
      tableRowOdd: '#ffffff',
      tableBorder: 'rgba(37,211,102,0.12)',
      tableCellHighlight: '#166534',
      tableCellWarn: '#92400e',
      tableCellDanger: '#dc2626',

      highlightSectionBg: '#E8F5E9',
      highlightSectionBorder: 'rgba(37,211,102,0.2)',
      calloutBg: '#E8F5E9',
      calloutBorder: '#25D366',
      calloutText: '#128C7E',

      verdictGreenBg: '#f0fdf4',
      verdictGreenText: '#166534',
      verdictRedBg: '#fef2f2',
      verdictRedText: '#991b1b',

      quickNavBg: '#ffffff',
      quickNavBorder: 'rgba(37,211,102,0.1)',
      quickNavText: '#6b6b6b',
      quickNavNum: '#25D366',
      quickNavHoverBg: '#E8F5E9',
      quickNavHoverText: '#128C7E',

      faqSectionBg: '#ffffff',
      faqSectionBorder: 'rgba(37,211,102,0.12)',
      faqQuestionBg: '#f8faf8',
      faqQuestionText: '#1a1a1a',
      faqAnswerBg: '#f0f9f4',

      backtopBg: '#25D366',
      backtopShadow: 'rgba(37,211,102,0.35)',
      backtopIcon: '#ffffff',

      riskText: '#b45309',
      dangerBg: '#fee2e2',
      dangerText: '#dc2626',
      warnBg: '#fef3c7',
      warnText: '#d97706',
      infoBg: '#e0f2fe',
      infoText: '#0369a1',

      dividerColor: 'rgba(37,211,102,0.12)',
      dividerLight: 'rgba(0,0,0,0.06)',
      selectionBg: 'rgba(37,211,102,0.2)',
      scrollbarThumb: 'rgba(37,211,102,0.3)',

      dlcardBg: '#f8faf8',
      dlcardBorder: 'rgba(37,211,102,0.15)',
      dlcardTitleText: '#1a1a1a',
      dlcardSubText: '#6b6b6b',
      dlpriceTagBg: '#dcfce7',
      dlpriceTagText: '#166534',
      dlverifiedBg: '#e9f7ef',
      dlverifiedText: '#128C7E',

      guideTableBorder: '2px solid #128C7E',
      guideTableHeaderBg: '#075E54',
      guideTableCellBg: '#128C7E',
      guideTableText: '#ffffff',
    },
  },
  {
    id: 'mint',
    name: 'Fresh Mint',
    nameCn: '清新薄荷绿',
    icon: '🌿',
    description: '清新自然，适合健康类网站',
    colors: {
      primary: '#4CAF50',
      primaryDark: '#2D7A4F',
      primaryLight: '#7BC67E',
      primaryPale: '#E8F8F0',
      primaryBg: '#F4FAF4',
      primaryBorder: 'rgba(76,175,80,0.15)',

      gradient: 'linear-gradient(135deg, #2D7A4F 0%, #4CAF50 100%)',
      gradientLight: 'linear-gradient(135deg, #4CAF50 0%, #7BC67E 100%)',
      gradientDark: 'linear-gradient(135deg, #1B5E20 0%, #2D7A4F 100%)',
      logoGradient: 'linear-gradient(135deg, #2D7A4F 0%, #4CAF50 100%)',
      footerGradient: 'linear-gradient(135deg, #1B5E20 0%, #2D7A4F 100%)',
      heroGradient: 'linear-gradient(135deg, #2D7A4F 0%, #4CAF50 100%)',

      pageBg: '#f7faf7',
      sectionBg: '#ffffff',
      sectionAltBg: '#f0f8f0',
      cardBg: '#ffffff',
      cardBg2: '#faffff',

      textMain: '#1a1a1a',
      textBody: '#3d3d3d',
      textMuted: '#6b6b6b',
      textFaint: '#9a9a9a',
      textInverse: '#ffffff',
      textBrand: '#4CAF50',
      textBrandDark: '#2D7A4F',

      navBg: 'rgba(255,255,255,0.97)',
      navBorder: 'rgba(76,175,80,0.12)',
      navHover: '#4CAF50',
      navActive: '#2D7A4F',
      navText: '#1a1a1a',
      mobileMenuBg: 'rgba(244,250,244,0.98)',
      mobileMenuBorder: 'rgba(76,175,80,0.1)',

      btnBg: '#4CAF50',
      btnBgDark: '#2D7A4F',
      btnText: '#ffffff',
      btnTextDark: '#ffffff',
      btnShadow: 'rgba(76,175,80,0.35)',
      btnShadowDark: 'rgba(45,122,79,0.4)',
      btnRadius: '999px',
      btnRadiusSm: '12px',
      btnBorder: 'transparent',

      ghostBtnBg: 'transparent',
      ghostBtnText: '#4CAF50',
      ghostBtnBorder: '#4CAF50',

      cardDownloadBg: '#4CAF50',
      cardDownloadHover: '#2D7A4F',
      cardDownloadText: '#ffffff',

      fixedBtnBg: 'linear-gradient(135deg, #2D7A4F 0%, #4CAF50 100%)',
      fixedBtnText: '#ffffff',

      cardBorder: 'rgba(76,175,80,0.1)',
      cardBorderHover: 'rgba(76,175,80,0.25)',
      cardShadow: '0 2px 12px rgba(76,175,80,0.06)',
      cardShadowMd: '0 4px 20px rgba(76,175,80,0.08)',
      cardShadowLg: '0 12px 40px rgba(76,175,80,0.12)',
      cardRadius: '16px',

      footerBg: '#1B5E20',
      footerBg2: '#2D7A4F',
      footerText: '#ffffff',
      footerTextMuted: 'rgba(255,255,255,0.75)',
      footerLink: 'rgba(255,255,255,0.85)',
      footerLinkHover: '#ffffff',

      border: 'rgba(76,175,80,0.1)',
      borderMid: 'rgba(76,175,80,0.18)',
      borderStrong: 'rgba(76,175,80,0.3)',
      borderInverse: 'rgba(255,255,255,0.15)',

      badgeBg: '#E8F8F0',
      badgeText: '#2D7A4F',
      badgeBorder: 'rgba(76,175,80,0.2)',
      badgeDot: '#4CAF50',

      tagWorksBg: '#dcfce7',
      tagWorksText: '#166534',
      tagRiskyBg: '#fef3c7',
      tagRiskyText: '#92400e',
      tagInfoBg: '#e0f2fe',
      tagInfoText: '#0369a1',
      tagDangerBg: '#fee2e2',
      tagDangerText: '#dc2626',
      tagWarnBg: '#fef3c7',
      tagWarnText: '#d97706',

      tableHeaderBg: '#E8F8F0',
      tableHeaderText: '#2D7A4F',
      tableRowEven: '#f0fdf7',
      tableRowOdd: '#ffffff',
      tableBorder: 'rgba(76,175,80,0.12)',
      tableCellHighlight: '#166534',
      tableCellWarn: '#92400e',
      tableCellDanger: '#dc2626',

      highlightSectionBg: '#E8F8F0',
      highlightSectionBorder: 'rgba(76,175,80,0.2)',
      calloutBg: '#E8F8F0',
      calloutBorder: '#4CAF50',
      calloutText: '#2D7A4F',

      verdictGreenBg: '#f0fdf4',
      verdictGreenText: '#166534',
      verdictRedBg: '#fef2f2',
      verdictRedText: '#991b1b',

      quickNavBg: '#ffffff',
      quickNavBorder: 'rgba(76,175,80,0.1)',
      quickNavText: '#6b6b6b',
      quickNavNum: '#4CAF50',
      quickNavHoverBg: '#E8F8F0',
      quickNavHoverText: '#2D7A4F',

      faqSectionBg: '#ffffff',
      faqSectionBorder: 'rgba(76,175,80,0.12)',
      faqQuestionBg: '#f8faf8',
      faqQuestionText: '#1a1a1a',
      faqAnswerBg: '#f0f8f0',

      backtopBg: '#4CAF50',
      backtopShadow: 'rgba(76,175,80,0.35)',
      backtopIcon: '#ffffff',

      riskText: '#b45309',
      dangerBg: '#fee2e2',
      dangerText: '#dc2626',
      warnBg: '#fef3c7',
      warnText: '#d97706',
      infoBg: '#e0f2fe',
      infoText: '#0369a1',

      dividerColor: 'rgba(76,175,80,0.12)',
      dividerLight: 'rgba(0,0,0,0.06)',
      selectionBg: 'rgba(76,175,80,0.2)',
      scrollbarThumb: 'rgba(76,175,80,0.3)',

      dlcardBg: '#f8faf8',
      dlcardBorder: 'rgba(76,175,80,0.15)',
      dlcardTitleText: '#1a1a1a',
      dlcardSubText: '#6b6b6b',
      dlpriceTagBg: '#dcfce7',
      dlpriceTagText: '#166534',
      dlverifiedBg: '#e9f7ef',
      dlverifiedText: '#2D7A4F',

      guideTableBorder: '2px solid #2D7A4F',
      guideTableHeaderBg: '#1B5E20',
      guideTableCellBg: '#2D7A4F',
      guideTableText: '#ffffff',
    },
  },
  {
    id: 'forest',
    name: 'Forest Green',
    nameCn: '森林深绿',
    icon: '🌲',
    description: '稳重深沉，适合金融科技',
    colors: {
      primary: '#43A047',
      primaryDark: '#1B5E20',
      primaryLight: '#66BB6A',
      primaryPale: '#E8F5E9',
      primaryBg: '#F2F8F2',
      primaryBorder: 'rgba(67,160,71,0.15)',

      gradient: 'linear-gradient(135deg, #1B5E20 0%, #43A047 100%)',
      gradientLight: 'linear-gradient(135deg, #43A047 0%, #66BB6A 100%)',
      gradientDark: 'linear-gradient(135deg, #0D3B14 0%, #1B5E20 100%)',
      logoGradient: 'linear-gradient(135deg, #1B5E20 0%, #43A047 100%)',
      footerGradient: 'linear-gradient(135deg, #0D3B14 0%, #1B5E20 100%)',
      heroGradient: 'linear-gradient(135deg, #1B5E20 0%, #43A047 100%)',

      pageBg: '#f5faf5',
      sectionBg: '#ffffff',
      sectionAltBg: '#eff8ef',
      cardBg: '#ffffff',
      cardBg2: '#faffff',

      textMain: '#1a1a1a',
      textBody: '#3d3d3d',
      textMuted: '#6b6b6b',
      textFaint: '#9a9a9a',
      textInverse: '#ffffff',
      textBrand: '#43A047',
      textBrandDark: '#1B5E20',

      navBg: 'rgba(255,255,255,0.97)',
      navBorder: 'rgba(67,160,71,0.12)',
      navHover: '#43A047',
      navActive: '#1B5E20',
      navText: '#1a1a1a',
      mobileMenuBg: 'rgba(242,248,242,0.98)',
      mobileMenuBorder: 'rgba(67,160,71,0.1)',

      btnBg: '#43A047',
      btnBgDark: '#1B5E20',
      btnText: '#ffffff',
      btnTextDark: '#ffffff',
      btnShadow: 'rgba(67,160,71,0.35)',
      btnShadowDark: 'rgba(27,94,32,0.4)',
      btnRadius: '999px',
      btnRadiusSm: '12px',
      btnBorder: 'transparent',

      ghostBtnBg: 'transparent',
      ghostBtnText: '#43A047',
      ghostBtnBorder: '#43A047',

      cardDownloadBg: '#43A047',
      cardDownloadHover: '#1B5E20',
      cardDownloadText: '#ffffff',

      fixedBtnBg: 'linear-gradient(135deg, #1B5E20 0%, #43A047 100%)',
      fixedBtnText: '#ffffff',

      cardBorder: 'rgba(67,160,71,0.1)',
      cardBorderHover: 'rgba(67,160,71,0.25)',
      cardShadow: '0 2px 12px rgba(67,160,71,0.06)',
      cardShadowMd: '0 4px 20px rgba(67,160,71,0.08)',
      cardShadowLg: '0 12px 40px rgba(67,160,71,0.12)',
      cardRadius: '16px',

      footerBg: '#0D3B14',
      footerBg2: '#1B5E20',
      footerText: '#ffffff',
      footerTextMuted: 'rgba(255,255,255,0.75)',
      footerLink: 'rgba(255,255,255,0.85)',
      footerLinkHover: '#ffffff',

      border: 'rgba(67,160,71,0.1)',
      borderMid: 'rgba(67,160,71,0.18)',
      borderStrong: 'rgba(67,160,71,0.3)',
      borderInverse: 'rgba(255,255,255,0.15)',

      badgeBg: '#E8F5E9',
      badgeText: '#1B5E20',
      badgeBorder: 'rgba(67,160,71,0.2)',
      badgeDot: '#43A047',

      tagWorksBg: '#dcfce7',
      tagWorksText: '#166534',
      tagRiskyBg: '#fef3c7',
      tagRiskyText: '#92400e',
      tagInfoBg: '#e0f2fe',
      tagInfoText: '#0369a1',
      tagDangerBg: '#fee2e2',
      tagDangerText: '#dc2626',
      tagWarnBg: '#fef3c7',
      tagWarnText: '#d97706',

      tableHeaderBg: '#E8F5E9',
      tableHeaderText: '#1B5E20',
      tableRowEven: '#f0fdf4',
      tableRowOdd: '#ffffff',
      tableBorder: 'rgba(67,160,71,0.12)',
      tableCellHighlight: '#166534',
      tableCellWarn: '#92400e',
      tableCellDanger: '#dc2626',

      highlightSectionBg: '#E8F5E9',
      highlightSectionBorder: 'rgba(67,160,71,0.2)',
      calloutBg: '#E8F5E9',
      calloutBorder: '#43A047',
      calloutText: '#1B5E20',

      verdictGreenBg: '#f0fdf4',
      verdictGreenText: '#166534',
      verdictRedBg: '#fef2f2',
      verdictRedText: '#991b1b',

      quickNavBg: '#ffffff',
      quickNavBorder: 'rgba(67,160,71,0.1)',
      quickNavText: '#6b6b6b',
      quickNavNum: '#43A047',
      quickNavHoverBg: '#E8F5E9',
      quickNavHoverText: '#1B5E20',

      faqSectionBg: '#ffffff',
      faqSectionBorder: 'rgba(67,160,71,0.12)',
      faqQuestionBg: '#f8faf8',
      faqQuestionText: '#1a1a1a',
      faqAnswerBg: '#f0f8f0',

      backtopBg: '#43A047',
      backtopShadow: 'rgba(67,160,71,0.35)',
      backtopIcon: '#ffffff',

      riskText: '#b45309',
      dangerBg: '#fee2e2',
      dangerText: '#dc2626',
      warnBg: '#fef3c7',
      warnText: '#d97706',
      infoBg: '#e0f2fe',
      infoText: '#0369a1',

      dividerColor: 'rgba(67,160,71,0.12)',
      dividerLight: 'rgba(0,0,0,0.06)',
      selectionBg: 'rgba(67,160,71,0.2)',
      scrollbarThumb: 'rgba(67,160,71,0.3)',

      dlcardBg: '#f8faf8',
      dlcardBorder: 'rgba(67,160,71,0.15)',
      dlcardTitleText: '#1a1a1a',
      dlcardSubText: '#6b6b6b',
      dlpriceTagBg: '#dcfce7',
      dlpriceTagText: '#166534',
      dlverifiedBg: '#e9f7ef',
      dlverifiedText: '#1B5E20',

      guideTableBorder: '2px solid #1B5E20',
      guideTableHeaderBg: '#0D3B14',
      guideTableCellBg: '#1B5E20',
      guideTableText: '#ffffff',
    },
  },
  {
    id: 'teal',
    name: 'Teal',
    nameCn: '青绿色',
    icon: '🧊',
    description: '科技感强，适合现代 App 网站',
    colors: {
      primary: '#00BCD4',
      primaryDark: '#00838F',
      primaryLight: '#26C6DA',
      primaryPale: '#E0F7FA',
      primaryBg: '#F0FBFC',
      primaryBorder: 'rgba(0,188,212,0.15)',

      gradient: 'linear-gradient(135deg, #00838F 0%, #00BCD4 100%)',
      gradientLight: 'linear-gradient(135deg, #00BCD4 0%, #26C6DA 100%)',
      gradientDark: 'linear-gradient(135deg, #006064 0%, #00838F 100%)',
      logoGradient: 'linear-gradient(135deg, #00838F 0%, #00BCD4 100%)',
      footerGradient: 'linear-gradient(135deg, #006064 0%, #00838F 100%)',
      heroGradient: 'linear-gradient(135deg, #00838F 0%, #00BCD4 100%)',

      pageBg: '#f5fafc',
      sectionBg: '#ffffff',
      sectionAltBg: '#eff9fb',
      cardBg: '#ffffff',
      cardBg2: '#faffff',

      textMain: '#1a1a1a',
      textBody: '#3d3d3d',
      textMuted: '#6b6b6b',
      textFaint: '#9a9a9a',
      textInverse: '#ffffff',
      textBrand: '#00BCD4',
      textBrandDark: '#00838F',

      navBg: 'rgba(255,255,255,0.97)',
      navBorder: 'rgba(0,188,212,0.12)',
      navHover: '#00BCD4',
      navActive: '#00838F',
      navText: '#1a1a1a',
      mobileMenuBg: 'rgba(240,251,252,0.98)',
      mobileMenuBorder: 'rgba(0,188,212,0.1)',

      btnBg: '#00BCD4',
      btnBgDark: '#00838F',
      btnText: '#ffffff',
      btnTextDark: '#ffffff',
      btnShadow: 'rgba(0,188,212,0.35)',
      btnShadowDark: 'rgba(0,131,143,0.4)',
      btnRadius: '999px',
      btnRadiusSm: '12px',
      btnBorder: 'transparent',

      ghostBtnBg: 'transparent',
      ghostBtnText: '#00BCD4',
      ghostBtnBorder: '#00BCD4',

      cardDownloadBg: '#00BCD4',
      cardDownloadHover: '#00838F',
      cardDownloadText: '#ffffff',

      fixedBtnBg: 'linear-gradient(135deg, #00838F 0%, #00BCD4 100%)',
      fixedBtnText: '#ffffff',

      cardBorder: 'rgba(0,188,212,0.1)',
      cardBorderHover: 'rgba(0,188,212,0.25)',
      cardShadow: '0 2px 12px rgba(0,188,212,0.06)',
      cardShadowMd: '0 4px 20px rgba(0,188,212,0.08)',
      cardShadowLg: '0 12px 40px rgba(0,188,212,0.12)',
      cardRadius: '16px',

      footerBg: '#006064',
      footerBg2: '#00838F',
      footerText: '#ffffff',
      footerTextMuted: 'rgba(255,255,255,0.75)',
      footerLink: 'rgba(255,255,255,0.85)',
      footerLinkHover: '#ffffff',

      border: 'rgba(0,188,212,0.1)',
      borderMid: 'rgba(0,188,212,0.18)',
      borderStrong: 'rgba(0,188,212,0.3)',
      borderInverse: 'rgba(255,255,255,0.15)',

      badgeBg: '#E0F7FA',
      badgeText: '#00838F',
      badgeBorder: 'rgba(0,188,212,0.2)',
      badgeDot: '#00BCD4',

      tagWorksBg: '#dcfce7',
      tagWorksText: '#166534',
      tagRiskyBg: '#fef3c7',
      tagRiskyText: '#92400e',
      tagInfoBg: '#e0f2fe',
      tagInfoText: '#0369a1',
      tagDangerBg: '#fee2e2',
      tagDangerText: '#dc2626',
      tagWarnBg: '#fef3c7',
      tagWarnText: '#d97706',

      tableHeaderBg: '#E0F7FA',
      tableHeaderText: '#00838F',
      tableRowEven: '#f0fbfd',
      tableRowOdd: '#ffffff',
      tableBorder: 'rgba(0,188,212,0.12)',
      tableCellHighlight: '#166534',
      tableCellWarn: '#92400e',
      tableCellDanger: '#dc2626',

      highlightSectionBg: '#E0F7FA',
      highlightSectionBorder: 'rgba(0,188,212,0.2)',
      calloutBg: '#E0F7FA',
      calloutBorder: '#00BCD4',
      calloutText: '#00838F',

      verdictGreenBg: '#f0fdf4',
      verdictGreenText: '#166534',
      verdictRedBg: '#fef2f2',
      verdictRedText: '#991b1b',

      quickNavBg: '#ffffff',
      quickNavBorder: 'rgba(0,188,212,0.1)',
      quickNavText: '#6b6b6b',
      quickNavNum: '#00BCD4',
      quickNavHoverBg: '#E0F7FA',
      quickNavHoverText: '#00838F',

      faqSectionBg: '#ffffff',
      faqSectionBorder: 'rgba(0,188,212,0.12)',
      faqQuestionBg: '#f8faf8',
      faqQuestionText: '#1a1a1a',
      faqAnswerBg: '#eff9fb',

      backtopBg: '#00BCD4',
      backtopShadow: 'rgba(0,188,212,0.35)',
      backtopIcon: '#ffffff',

      riskText: '#b45309',
      dangerBg: '#fee2e2',
      dangerText: '#dc2626',
      warnBg: '#fef3c7',
      warnText: '#d97706',
      infoBg: '#e0f2fe',
      infoText: '#0369a1',

      dividerColor: 'rgba(0,188,212,0.12)',
      dividerLight: 'rgba(0,0,0,0.06)',
      selectionBg: 'rgba(0,188,212,0.2)',
      scrollbarThumb: 'rgba(0,188,212,0.3)',

      dlcardBg: '#f8faf8',
      dlcardBorder: 'rgba(0,188,212,0.15)',
      dlcardTitleText: '#1a1a1a',
      dlcardSubText: '#6b6b6b',
      dlpriceTagBg: '#dcfce7',
      dlpriceTagText: '#166534',
      dlverifiedBg: '#e9f7ef',
      dlverifiedText: '#00838F',

      guideTableBorder: '2px solid #00838F',
      guideTableHeaderBg: '#006064',
      guideTableCellBg: '#00838F',
      guideTableText: '#ffffff',
    },
  },
  {
    id: 'yellowgreen',
    name: 'Yellow Green',
    nameCn: '黄绿色',
    icon: '🌾',
    description: '活力四射，适合年轻化网站',
    colors: {
      primary: '#8BC34A',
      primaryDark: '#558B2F',
      primaryLight: '#B8D964',
      primaryPale: '#F0F4D0',
      primaryBg: '#F8FAF0',
      primaryBorder: 'rgba(139,195,74,0.15)',

      gradient: 'linear-gradient(135deg, #558B2F 0%, #8BC34A 100%)',
      gradientLight: 'linear-gradient(135deg, #8BC34A 0%, #B8D964 100%)',
      gradientDark: 'linear-gradient(135deg, #33691E 0%, #558B2F 100%)',
      logoGradient: 'linear-gradient(135deg, #558B2F 0%, #8BC34A 100%)',
      footerGradient: 'linear-gradient(135deg, #33691E 0%, #558B2F 100%)',
      heroGradient: 'linear-gradient(135deg, #558B2F 0%, #8BC34A 100%)',

      pageBg: '#f8faf5',
      sectionBg: '#ffffff',
      sectionAltBg: '#f6f9f0',
      cardBg: '#ffffff',
      cardBg2: '#fffff8',

      textMain: '#1a1a1a',
      textBody: '#3d3d3d',
      textMuted: '#6b6b6b',
      textFaint: '#9a9a9a',
      textInverse: '#ffffff',
      textBrand: '#8BC34A',
      textBrandDark: '#558B2F',

      navBg: 'rgba(255,255,255,0.97)',
      navBorder: 'rgba(139,195,74,0.12)',
      navHover: '#8BC34A',
      navActive: '#558B2F',
      navText: '#1a1a1a',
      mobileMenuBg: 'rgba(248,250,240,0.98)',
      mobileMenuBorder: 'rgba(139,195,74,0.1)',

      btnBg: '#8BC34A',
      btnBgDark: '#558B2F',
      btnText: '#ffffff',
      btnTextDark: '#ffffff',
      btnShadow: 'rgba(139,195,74,0.35)',
      btnShadowDark: 'rgba(85,139,47,0.4)',
      btnRadius: '999px',
      btnRadiusSm: '12px',
      btnBorder: 'transparent',

      ghostBtnBg: 'transparent',
      ghostBtnText: '#8BC34A',
      ghostBtnBorder: '#8BC34A',

      cardDownloadBg: '#8BC34A',
      cardDownloadHover: '#558B2F',
      cardDownloadText: '#ffffff',

      fixedBtnBg: 'linear-gradient(135deg, #558B2F 0%, #8BC34A 100%)',
      fixedBtnText: '#ffffff',

      cardBorder: 'rgba(139,195,74,0.1)',
      cardBorderHover: 'rgba(139,195,74,0.25)',
      cardShadow: '0 2px 12px rgba(139,195,74,0.06)',
      cardShadowMd: '0 4px 20px rgba(139,195,74,0.08)',
      cardShadowLg: '0 12px 40px rgba(139,195,74,0.12)',
      cardRadius: '16px',

      footerBg: '#33691E',
      footerBg2: '#558B2F',
      footerText: '#ffffff',
      footerTextMuted: 'rgba(255,255,255,0.75)',
      footerLink: 'rgba(255,255,255,0.85)',
      footerLinkHover: '#ffffff',

      border: 'rgba(139,195,74,0.1)',
      borderMid: 'rgba(139,195,74,0.18)',
      borderStrong: 'rgba(139,195,74,0.3)',
      borderInverse: 'rgba(255,255,255,0.15)',

      badgeBg: '#F0F4D0',
      badgeText: '#558B2F',
      badgeBorder: 'rgba(139,195,74,0.2)',
      badgeDot: '#8BC34A',

      tagWorksBg: '#dcfce7',
      tagWorksText: '#166534',
      tagRiskyBg: '#fef3c7',
      tagRiskyText: '#92400e',
      tagInfoBg: '#e0f2fe',
      tagInfoText: '#0369a1',
      tagDangerBg: '#fee2e2',
      tagDangerText: '#dc2626',
      tagWarnBg: '#fef3c7',
      tagWarnText: '#d97706',

      tableHeaderBg: '#F0F4D0',
      tableHeaderText: '#558B2F',
      tableRowEven: '#f8fbf0',
      tableRowOdd: '#ffffff',
      tableBorder: 'rgba(139,195,74,0.12)',
      tableCellHighlight: '#166534',
      tableCellWarn: '#92400e',
      tableCellDanger: '#dc2626',

      highlightSectionBg: '#F0F4D0',
      highlightSectionBorder: 'rgba(139,195,74,0.2)',
      calloutBg: '#F0F4D0',
      calloutBorder: '#8BC34A',
      calloutText: '#558B2F',

      verdictGreenBg: '#f0fdf4',
      verdictGreenText: '#166534',
      verdictRedBg: '#fef2f2',
      verdictRedText: '#991b1b',

      quickNavBg: '#ffffff',
      quickNavBorder: 'rgba(139,195,74,0.1)',
      quickNavText: '#6b6b6b',
      quickNavNum: '#8BC34A',
      quickNavHoverBg: '#F0F4D0',
      quickNavHoverText: '#558B2F',

      faqSectionBg: '#ffffff',
      faqSectionBorder: 'rgba(139,195,74,0.12)',
      faqQuestionBg: '#f8faf8',
      faqQuestionText: '#1a1a1a',
      faqAnswerBg: '#f8faf0',

      backtopBg: '#8BC34A',
      backtopShadow: 'rgba(139,195,74,0.35)',
      backtopIcon: '#ffffff',

      riskText: '#b45309',
      dangerBg: '#fee2e2',
      dangerText: '#dc2626',
      warnBg: '#fef3c7',
      warnText: '#d97706',
      infoBg: '#e0f2fe',
      infoText: '#0369a1',

      dividerColor: 'rgba(139,195,74,0.12)',
      dividerLight: 'rgba(0,0,0,0.06)',
      selectionBg: 'rgba(139,195,74,0.2)',
      scrollbarThumb: 'rgba(139,195,74,0.3)',

      dlcardBg: '#f8faf8',
      dlcardBorder: 'rgba(139,195,74,0.15)',
      dlcardTitleText: '#1a1a1a',
      dlcardSubText: '#6b6b6b',
      dlpriceTagBg: '#dcfce7',
      dlpriceTagText: '#166534',
      dlverifiedBg: '#e9f7ef',
      dlverifiedText: '#558B2F',

      guideTableBorder: '2px solid #558B2F',
      guideTableHeaderBg: '#33691E',
      guideTableCellBg: '#558B2F',
      guideTableText: '#ffffff',
    },
  },
  {
    id: 'darkforest',
    name: 'Dark Forest',
    nameCn: '深墨绿',
    icon: '🍃',
    description: '复古沉稳，适合高质感网站',
    colors: {
      primary: '#4CAF50',
      primaryDark: '#0D3B14',
      primaryLight: '#81C784',
      primaryPale: '#E8F5E9',
      primaryBg: '#F0F4F0',
      primaryBorder: 'rgba(76,175,80,0.15)',

      gradient: 'linear-gradient(135deg, #0D3B14 0%, #4CAF50 100%)',
      gradientLight: 'linear-gradient(135deg, #4CAF50 0%, #81C784 100%)',
      gradientDark: 'linear-gradient(135deg, #081f0c 0%, #0D3B14 100%)',
      logoGradient: 'linear-gradient(135deg, #0D3B14 0%, #4CAF50 100%)',
      footerGradient: 'linear-gradient(135deg, #081f0c 0%, #0D3B14 100%)',
      heroGradient: 'linear-gradient(135deg, #0D3B14 0%, #4CAF50 100%)',

      pageBg: '#f3f6f3',
      sectionBg: '#ffffff',
      sectionAltBg: '#ecf3ec',
      cardBg: '#ffffff',
      cardBg2: '#faffff',

      textMain: '#1a1a1a',
      textBody: '#3d3d3d',
      textMuted: '#6b6b6b',
      textFaint: '#9a9a9a',
      textInverse: '#ffffff',
      textBrand: '#4CAF50',
      textBrandDark: '#0D3B14',

      navBg: 'rgba(255,255,255,0.97)',
      navBorder: 'rgba(76,175,80,0.12)',
      navHover: '#4CAF50',
      navActive: '#0D3B14',
      navText: '#1a1a1a',
      mobileMenuBg: 'rgba(240,244,240,0.98)',
      mobileMenuBorder: 'rgba(76,175,80,0.1)',

      btnBg: '#4CAF50',
      btnBgDark: '#0D3B14',
      btnText: '#ffffff',
      btnTextDark: '#ffffff',
      btnShadow: 'rgba(76,175,80,0.35)',
      btnShadowDark: 'rgba(13,59,20,0.4)',
      btnRadius: '999px',
      btnRadiusSm: '12px',
      btnBorder: 'transparent',

      ghostBtnBg: 'transparent',
      ghostBtnText: '#4CAF50',
      ghostBtnBorder: '#4CAF50',

      cardDownloadBg: '#4CAF50',
      cardDownloadHover: '#0D3B14',
      cardDownloadText: '#ffffff',

      fixedBtnBg: 'linear-gradient(135deg, #0D3B14 0%, #4CAF50 100%)',
      fixedBtnText: '#ffffff',

      cardBorder: 'rgba(76,175,80,0.1)',
      cardBorderHover: 'rgba(76,175,80,0.25)',
      cardShadow: '0 2px 12px rgba(76,175,80,0.06)',
      cardShadowMd: '0 4px 20px rgba(76,175,80,0.08)',
      cardShadowLg: '0 12px 40px rgba(76,175,80,0.12)',
      cardRadius: '16px',

      footerBg: '#081f0c',
      footerBg2: '#0D3B14',
      footerText: '#ffffff',
      footerTextMuted: 'rgba(255,255,255,0.75)',
      footerLink: 'rgba(255,255,255,0.85)',
      footerLinkHover: '#ffffff',

      border: 'rgba(76,175,80,0.1)',
      borderMid: 'rgba(76,175,80,0.18)',
      borderStrong: 'rgba(76,175,80,0.3)',
      borderInverse: 'rgba(255,255,255,0.15)',

      badgeBg: '#E8F5E9',
      badgeText: '#0D3B14',
      badgeBorder: 'rgba(76,175,80,0.2)',
      badgeDot: '#4CAF50',

      tagWorksBg: '#dcfce7',
      tagWorksText: '#166534',
      tagRiskyBg: '#fef3c7',
      tagRiskyText: '#92400e',
      tagInfoBg: '#e0f2fe',
      tagInfoText: '#0369a1',
      tagDangerBg: '#fee2e2',
      tagDangerText: '#dc2626',
      tagWarnBg: '#fef3c7',
      tagWarnText: '#d97706',

      tableHeaderBg: '#E8F5E9',
      tableHeaderText: '#0D3B14',
      tableRowEven: '#f0fdf4',
      tableRowOdd: '#ffffff',
      tableBorder: 'rgba(76,175,80,0.12)',
      tableCellHighlight: '#166534',
      tableCellWarn: '#92400e',
      tableCellDanger: '#dc2626',

      highlightSectionBg: '#E8F5E9',
      highlightSectionBorder: 'rgba(76,175,80,0.2)',
      calloutBg: '#E8F5E9',
      calloutBorder: '#4CAF50',
      calloutText: '#0D3B14',

      verdictGreenBg: '#f0fdf4',
      verdictGreenText: '#166534',
      verdictRedBg: '#fef2f2',
      verdictRedText: '#991b1b',

      quickNavBg: '#ffffff',
      quickNavBorder: 'rgba(76,175,80,0.1)',
      quickNavText: '#6b6b6b',
      quickNavNum: '#4CAF50',
      quickNavHoverBg: '#E8F5E9',
      quickNavHoverText: '#0D3B14',

      faqSectionBg: '#ffffff',
      faqSectionBorder: 'rgba(76,175,80,0.12)',
      faqQuestionBg: '#f8faf8',
      faqQuestionText: '#1a1a1a',
      faqAnswerBg: '#ecf3ec',

      backtopBg: '#4CAF50',
      backtopShadow: 'rgba(76,175,80,0.35)',
      backtopIcon: '#ffffff',

      riskText: '#b45309',
      dangerBg: '#fee2e2',
      dangerText: '#dc2626',
      warnBg: '#fef3c7',
      warnText: '#d97706',
      infoBg: '#e0f2fe',
      infoText: '#0369a1',

      dividerColor: 'rgba(76,175,80,0.12)',
      dividerLight: 'rgba(0,0,0,0.06)',
      selectionBg: 'rgba(76,175,80,0.2)',
      scrollbarThumb: 'rgba(76,175,80,0.3)',

      dlcardBg: '#f8faf8',
      dlcardBorder: 'rgba(76,175,80,0.15)',
      dlcardTitleText: '#1a1a1a',
      dlcardSubText: '#6b6b6b',
      dlpriceTagBg: '#dcfce7',
      dlpriceTagText: '#166534',
      dlverifiedBg: '#e9f7ef',
      dlverifiedText: '#0D3B14',

      guideTableBorder: '2px solid #0D3B14',
      guideTableHeaderBg: '#081f0c',
      guideTableCellBg: '#0D3B14',
      guideTableText: '#ffffff',
    },
  },
];

export const DEFAULT_THEME = 'emerald';
